import { useBoundStore } from '../../../../stores';
import { Delete, Edit, LinkOff, Visibility } from '@mui/icons-material';
import { IconButton } from '@mui/material';
import PermissionToRender from '../../../../components/Permission/PermissionToRender';
import { useNavigate } from 'react-router-dom';

function RelationColumns(handleUpdateRelation, handleRelation) {
  const navigate = useNavigate();
  const textPool = useBoundStore((state) => state.textPool);
  const toggleLeftDrawer = useBoundStore((state) => state.toggleLeftDrawer);

  return [
    {
      field: 'iccid',
      headerName: "ICC ID",
      width: 200,
      renderCell: (data) => {
        return data.row.simcardId.iccid
      }
    },
    {
      field: 'simcardId.barcodeNumber',
      headerName: "SIM Barkod Numarası",
      width: 200,
      renderCell: (data) => {
        return data.row.simcardId.barcodeNumber
      }
    },
    {
      field: 'deviceId.imei',
      headerName: "Eşlenen Cihaz IMEI",
      width: 150,
      renderCell: (data) => {
        return data.row.deviceId.imei
      }
    },
    {
      field: 'deviceId.barcodeNumber',
      headerName: "Cihaz Barkod Numarası",
      width: 200,
      renderCell: (data) => {
        return data.row.deviceId.barcodeNumber
      }
    },
    {
      field: 'createdAt',
      headerName: textPool['Oluşturma Tarihi'],
      width: 150,
      notFilter: true,
      renderCell: (data) =>
        data.row.createdAt ? (
          <div>
            {data?.row?.createdAt
              ? new Date(data?.row?.createdAt).toLocaleString('tr')
              : ''}
          </div>
        ) : (
          <span className="font-bold">Eşleşme Yok</span>
        ),
    },
    {
      field: 'actions',
      headerName: 'İşlemler',
      width: 100,
      sortable: false,
      align: 'center',
      renderCell: (params) => {
        return (
          <div className="flex flex-row">
            <IconButton
              onClick={() => {
                navigate(`/definitions/simcards/#${params.row.id}`);
                handleUpdateRelation(params.row)
              }}
            >
              <Edit />
            </IconButton>
            <IconButton
              disabled={!params.row.id}
              onClick={() => handleRelation(params.row)}
            >
              <LinkOff />
            </IconButton>
          </div>
        );
      },
    },
  ];
}
export { RelationColumns as relation_columns };
